import axios from "axios";
import { endpoints } from "@app/api/apis";




export const getBanksList = async () => {
  const response = await axios.get(endpoints.allBanks);
  return response.data;
};